import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconStopwatchComponent } from "./med-icon-stopwatch.component";

@NgModule({
  declarations: [
    MedIconStopwatchComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconStopwatchComponent,
  ],
})
export class MedIconStopwatchModule { }
